class Share {
  constructor(element) {
    this.element = element;
    this.value = this.element.dataset.value;
    this.btnLink = this.element.querySelector('[data-element="link"]');
  }

  init() {
    this.btnLink.addEventListener( 'click', this.copyToClipboard.bind( this ) );
  }

  copyToClipboard(event) {
    event.preventDefault();
    try {
      navigator.clipboard.writeText(this.value);
      this.btnLink.classList.add('share__button--active');
      setTimeout(() => {
        this.btnLink.classList.remove('share__button--active');
      }, 3000);
    } catch (error) {
      console.error('Failed to copy!', error);
    }
  }
}

const share = {
  init() {
    const shareElements = document.querySelectorAll('[data-module="share"]');

    if (shareElements && shareElements.length) {
      shareElements.forEach((element) => {
        const shareElement = new Share(element);
        shareElement.init();
      });
    }
  },
};

export default share;
